import { DefaultImageProps } from './types';
import { FAB_WEBSHOP_NAVBAR_LOGO_IMAGE_URL } from './urls';

export const FabWebshopNavbarLogoImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={FAB_WEBSHOP_NAVBAR_LOGO_IMAGE_URL}
    alt="fab-webshop-navbar-logo"
    {...props}
  />
);
